<template>
  <tr :class="{ selected: selected }">
    <td colspan="2">
      <div class="name-wrapper">
        <button
          class="btn btn-xs fav-button"
          :disabled="item.isDisabled"
          @click.prevent="addFav(item)"
        >
          <span class="fav-icon">
            <i :class="calculateClass()"></i>
          </span>
        </button>
        <div
          class="selector"
          :title="stypeName[item.stype]"
          @click.stop="selectBrand()"
        >
          <p class="symbol">
            {{ item.symbol | symbol }}
            <span class="exchange-code">/ {{ item.exchange_server_code ?? '--' }}</span>

            <span class="name"> • {{ stypeName[item.stype] }}</span>
          </p>
          <p class="name" v-if="item.company_name" :title="item.company_name">
            {{ item.company_name }}
          </p>
          <p class="name" v-else :title="item.company_symbol_name">
            {{ item.company_symbol_name }}
          </p>
        </div>
      </div>
    </td>
    <td class="right price">
      {{
        brand.stype === 2 && brand.bond_type === 100
                    ? brand.closing_price * 1000
                    : brand.closing_price | currency('', '')
      }}
    </td>
    <td class="right">
      <div class="change">
        <p
          class="percent-change"
          :class="getClass(item.previous_day_ratio_percent)"
        >
          {{
            (item.previous_day_ratio_value >= 0 ? '+' : '') +
            parseFloat(item.previous_day_ratio_percent).toFixed(2)
          }}%
        </p>
        <p class="value" :class="getClass(item.previous_day_ratio_value)">
          {{
            (item.previous_day_ratio_value >= 0 ? '+' : '') +
            parseFloat(item.previous_day_ratio_value).toFixed(2)
          }}₮
        </p>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import api from '../api/stoTrade'

const stypeName = {
  1: 'Хувьцаа',
  2: 'Компанийн бонд',
  3: 'Засгийн газрын бонд',
}

export default {
  props: {
    brand: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      stypeName,
      mouseOver: false,
      iconClass: '',
      item: this.brand || {},
    }
  },
  mounted() {
    this.iconClass = this.calculateClass(this.item.isFavorite)
    if (!this.selectedBrand.id) {
      this.setBrand(this.item)
    }
  },
  computed: {
    ...mapState('brand', {
      favoriteBrands: ['favoriteBrands'],
      selectedBrand: ['brand'],
    }),
    ...mapState('brand', ['favoriteBrandsMap']),
    isFavorite: {
      get() {
        return typeof this.favoriteBrandsMap[this.brand.symbol] !== 'undefined'
      },
    },
  },
  watch: {
    isFavorite(val, n) {
      this.iconClass = this.calculateClass(val)
    },
    brand: function (val) {
      this.item = val
    },
  },
  methods: {
    ...mapActions('brand', ['setFavoriteBrands', 'setBrand']),
    ...mapActions('cent', ['unsubscribeCurrent']),
    calculateClass() {
      return this.isFavorite ? 'sr sr-star text-warning' : 'sr sr-starspeed'
    },
    stypeVariant(type) {
      return {
        'badge-info': type === 1,
        'badge-success': type === 2,
        'badge-warning': type === 3,
      }
    },
    getClass(value) {
      if (value >= 0) {
        return 'text-green'
      } else if (value < 0) {
        return 'text-red'
      }
    },
    selectBrand() {
      // Хэрэв өмнө socket-д холбогдсон байвал түүнийг салгах шаардлагатай болсон.
      // тэгэхгүй бол дараагийн сонгосон хувьцааны мэдээллийг дараад байна.
      // this.unsubscribeCurrent()
      this.setBrand(this.item)
    },
    async addFav() {
      try {
        const favoriteBrands = this.favoriteBrands
        const item = this.item
        if (!this.item.isFavorite) {
          await api.addFavoriteBrand({
            symbol: item.symbol,
            company_symbol_name: item.company_name || item.company_symbol_name,
          })
          favoriteBrands.push(this.item)
          this.item.isFavorite = !this.item.isFavorite
          this.setFavoriteBrands(favoriteBrands)

          if (this.selectedBrand.id !== item.id) {
            this.selectBrand()
          }
        } else {
          this.removeFav()
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.$forceUpdate()
      }
    },
    async removeFav() {
      try {
        await api.removeFavoriteBrand({ symbol: this.item.symbol })
        const favoriteBrands = this.favoriteBrands.filter(
          (brand) => brand.symbol !== this.item.symbol
        )
        this.item.isFavorite = !this.item.isFavorite
        this.setFavoriteBrands(favoriteBrands)
        this.$forceUpdate()
      } catch (e) {
        console.error(e)
      }
    },
  },
}
</script>
